<template>
  <div class="row">
    
    <!-- <div class="col-lg-3">
      <div class="m-0 block block-rounded border">
        <div class="block-header bg-success-light">
          <h6 class="m-0">LEGEND</h6>
        </div>
        <div class="block-content p-3" style="font-size:14px;font-weight: bold;">
          <div v-for="(value,key) in chart_config">
            <div v-if="!['year','enable_modify'].includes(key)"><span class="fa fa-square px-1" :style="{'color':value.color}"></span><span :style="{'color':value.color}">{{key}}</span></div>
          </div>
        </div>
      </div>  
    </div> -->
  
    <div class="col-lg-12 text-center table-responsive">
      <Chart
        :size="{ width: 900, height: 420 }"
        :data="data"
        :margin="margin"
        :direction="direction"
        :axis="axis">

        <template #layers>
          <Grid strokeDasharray="1,1" />
          <!-- <Bar :dataKeys="['year', 'begin_balance']" :barStyle="{ fill: chart_config.begin_balance.color }" /> -->
          <!-- <Bar :dataKeys="['year', 'annual_amount']" :barStyle="{ fill: chart_config.annual_amount.color }" /> -->
          <Bar :dataKeys="['year', 'total_annual']" :barStyle="{ fill: chart_config.total_annual.color }" />
          <!-- <Bar :dataKeys="['year', 'withdraw']" :barStyle="{ fill: chart_config.withdraw.color }" /> -->
          <!-- <Bar :dataKeys="['year', 'earn']" :barStyle="{ fill: chart_config.earn.color }" /> -->
          <Bar :dataKeys="['year', 'total_earn']" :barStyle="{ fill: chart_config.total_earn.color }" />
          <Bar :dataKeys="['year', 'end_balance']" :barStyle="{ fill: chart_config.end_balance.color }" />
        </template>

        <template #widgets>
          <Tooltip
            borderColor="#48CAE4"
            :config="chart_config"
          />
        </template>

      </Chart>

      <div class="mt-3">
        <span v-for="(value,key) in chart_config">
          <span v-if="['total_annual','total_earn','end_balance'].includes(key)" class="m-3">
            <span class="fa fa-square px-1" :style="{'color':value.color}"></span>
            <span class="text-bold" :style="{'color':value.color}">{{value.label}}</span>
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, reactive, watch } from 'vue'
import { Chart, Grid, Bar, Tooltip } from 'vue3-charts'

export default defineComponent({
  components: { Chart, Grid, Bar, Tooltip },
  mounted(){
    var new_data    = [];
    
    for (var i = 0; i < (this.$parent.data.calculate_data).length; i++) {
      var entry = (this.$parent.data.calculate_data)[i];
      for (const [key, value] of Object.entries(entry)) {
        if(key!='year' && key!='enable_modify'){
          entry[key] = parseFloat(value);
        }else if(key=='year'){
          entry[key] = value.toString();
        }

      }
      new_data.push(entry);
    }
    this.data = new_data;
    
  },
  setup() {

    const data = ref();
    const direction = ref('horizontal')
    const margin = ref({
      left: 0,
      top: 20,
      right: 20,
      bottom: 0
    })

    const axis = ref({
      primary: {
        type: 'band'
      },
      secondary: {
        domain: ['dataMin', 'dataMax + 100'],
        type: 'linear',
        ticks: 5
      }
    })

    const chart_config = reactive({
      year            : { color: '#000000',label:'Year' },
      begin_balance   : { color: '#25b673',hide: true },
      annual_amount   : { color: '#ffc107',hide:true },
      total_annual    : { color: '#fd7e14',label:'Total Annual Contribution' },
      withdraw        : { color: '#dc2626',hide: true },
      earn            : { color: '#0dcaf0',hide: true },
      total_earn      : { color: '#0d6efd',label:'Total Interest Earned' },
      end_balance     : { color: '#22844b',label:'Ending Balance' },
      enable_modify   : { hide: true }
    })

    const getData = (new_data) => {
      
      var new_entry = [];
      
      for (var i = 0; i < new_data.length; i++) {
        var entry = new_data[i];
        for (const [key, value] of Object.entries(entry)) {
          if(key!='year' && key!='enable_modify'){
            entry[key] = parseFloat(value);
          }else if(key=='year'){
            entry[key] = value.toString();
          }
        }
        new_entry.push(entry);
      }

      data.value = new_entry;

    }

    return { data, getData, direction, margin, axis, chart_config }
  }
})
</script>